import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { setCurrentApp } from './actions/actions';
import WelcomeScreen from './components/WelcomeScreen/WelcomeScreen';
import TopicList from './components/TopicList/TopicList';

const jQuery = window.jQuery;

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			welcomeScreen: true
		}
		this.appName = this.props.setApp;
		if (this.props.setApp === 'EZ-Talk') this.currentApp = 'app-1';
		if (this.props.setApp === 'EZ-C') this.currentApp = 'app-2';
		if (this.props.setApp === 'EZ-Reading') this.currentApp = 'app-3';
		this.props.setCurrentApp({ currentApp: this.currentApp });
		document.title = this.props.setApp;     // setting the HTML page title
	};

	toggleScreenState = welcomeScreenState => {
		this.setState({
			welcomeScreen: welcomeScreenState,
		}, () => {
			if (this.state.welcomeScreen) {
				jQuery("#colophon").show();
				jQuery(".entry-header").show();
				jQuery(".site-header").show();
			}
		});

		if (!welcomeScreenState) {
			document.body.classList.add(`open-app`);
			document.body.classList.add(`${this.currentApp}`);
		} else {
			document.body.classList.remove('open-app');
			document.body.classList.remove(`${this.currentApp}`);
		}
	};

	componentDidMount() {
		if (!this.state.welcomeScreen){
			document.body.classList.add(`open-app`);
			document.body.classList.add(`${this.currentApp}`)
		} else {
			document.body.classList.remove('open-app');
			document.body.classList.remove(`${this.currentApp}`);
		}
	}

	render() {
		const appContainer = (
			<div className='main-container'>
				<TopicList closeApp={() => this.toggleScreenState(true)} />
			</div>
		);

		return (
			<Fragment>
				<WelcomeScreen
					showScreen={this.state.welcomeScreen}
					currentApp={this.currentApp}
					appName={this.appName}
					toggleScreenState={() => this.toggleScreenState(false)}
				/>
				{this.state.welcomeScreen ? null : appContainer}
			</Fragment>
		)
	}
}

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp
});

const mapDispatchToProps = dispatch => ({
	setCurrentApp: params => dispatch(setCurrentApp(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);